/* eslint-disable */

// todo make a proper jQuery plugin

const settings = {
    html: `<div class="o-spinner"><div class="o-spinner__axis"><div class="o-spinner__container"><div class="o-spinner__inner"></div></div></div></div>`,
    delayBeforeAppear: 0,
    onStartLoading: $.noop(),
    onFinishLoading: $.noop(),
    startOnInit: true,
    fullScreen: false,
    size: 50,
    position: 'inline',
    backgroundColor: false,
    preventDuplicate: true,
    destroyOnStop: true,
    zIndex: 100
};

const init = function (config) {
    return this.each(function () {
        const self = this;


        $(this).data('alreadyLoaded', 'false');
        $(this).data('timeout', null);

        const methods = {
            exists () {
                return self.$loader !== undefined ? !!self.$loader.length : false;
            },
            start () {
                if (typeof self.settings !== 'undefined')
                {
                    if (typeof self.settings.onStartLoading === 'function')
                    {
                        self.settings.onStartLoading();
                    }
                }
            },
            stop () {
                if (typeof self.settings !== 'undefined')
                {
                    $(self).data('alreadyLoaded', 'true');

                    if (typeof self.settings.onFinishLoading === 'function')
                    {
                        self.settings.onFinishLoading();
                    }

                    clearTimeout($(self).data('timeout'));

                    if (self.$loader !== undefined)
                    {
                        self.$loader.removeClass('is-loading');

                        setTimeout(() => {
                            if (self.settings.destroyOnStop)
                            {
                                if (typeof self.$loader !== 'undefined')
                                {
                                    self.$loader.remove();
                                }
                            }
                        }, 300);
                    }
                }
            },
            destroy () {
                if (typeof self.$loader !== 'undefined')
                {
                    self.$loader.remove();
                }
            }
        };

        if (typeof config === 'object' || typeof config === 'undefined')
        {
            this.settings = $.extend({}, settings, config);

            // check duplicates
            if ((!this.settings.preventDuplicate || this.settings.preventDuplicate) && !$(this).children('.o-spinner').length)
            {
                $(this).prepend(this.settings.html);
            }

            self.$loader = $(this).children('.o-spinner');

            if (this.settings.fullScreen)
            {
                self.$loader.wrap('<div class="o-spinner-wrap"></div>');
            }

            if (this.settings.position === 'inline')
            {
                self.$loader.addClass('o-spinner--inline');
            }

            if (this.settings.size <= 20)
            {
                throw new Error(`Oops! Please enter a size greater then 20px.`);
            }

            self.$loader.css({
                width: this.settings.size,
                height: this.settings.size,
                marginLeft: this.settings.size / -2,
                marginTop: this.settings.size / -2,
                zIndex: this.settings.zIndex
            });

            setTimeout(() => {
                self.$loader.addClass('is-loading');
            }, 150);

            if (self.settings.startOnInit)
            {
                methods.start.apply(this, []);
            }
        }
        else if (typeof config === 'string' && typeof methods[config] !== 'undefined')
        {
            methods[config].apply(this, []);
        }
    });
};

$.fn.loader = function () {
    init.apply(this, arguments);
};



// WEBPACK FOOTER //
// ./app/src/js/utils/loader.js